export * from './daily-staging-pay-add-edit.component'